<script setup lang="ts">
import {Button, Drawer, Icon} from "@/Components/Library";
import {useRouter} from "vue-router";

const router = useRouter();

const {question} = defineProps<{question: any}>();
const visible = defineModel<boolean>("visible");
</script>
<template>
    <Drawer
        v-model:visible="visible"
        position="bottom"
        header="Question Actions"
        class="relative max-h-dvh max-w-3xl overflow-y-auto"
        :showCloseIcon="false"
    >
        <div class="flex flex-col items-center pb-12">
            <Icon icon="mingcute:send-plane-fill" class="mb-6 text-7xl text-askr-green" />
            <p class="mb-4 text-center">What do you want to do next?</p>
            <div class="flex w-full flex-col gap-2">
                <RouterLink
                    :to="{
                        name: 'questions.launch',
                        query: {
                            ...router.currentRoute.value.query,
                            launch: 'true',
                            question: question.id,
                            from: undefined,
                        },
                    }"
                >
                    <Button :icon="{icon: 'mingcute:send-plane-fill'}" class="w-full bg-askr-green text-white">
                        Launch posts
                    </Button>
                </RouterLink>
                <RouterLink :to="{name: 'questions.create'}">
                    <Button :icon="{icon: 'mdi:plus'}" class="w-full bg-askr-green text-white">Add another post</Button>
                </RouterLink>
            </div>
        </div>
    </Drawer>
</template>
<style scoped></style>
